import api from '@/config/api'
import vuex from '@/store'
import dayjs from 'dayjs'

export default {
  searchArchiveDate(date, station_name) {
    if (!date) return []
    station_name = station_name ?? vuex.getters.currentStation.station_name
    let params = {
      'air_date>': dayjs(date).tz(vuex.getters.currentTimezone).startOf('day').toISOString(),
      'air_date<': dayjs(date).tz(vuex.getters.currentTimezone).endOf('day').toISOString(),
      limit: 8000,
      station: station_name
    }
    return api.get(`/v2/newsdesk/archive_rundowns`, { params })
  },
  searchArchiveAssignment(assignment_id, station) {
    if (!assignment_id) return []
    station = station ?? vuex.getters.currentStation.station
    let params = {
      assignment_id,
      limit: 20,
      station
    }
    return api.get(`/v2/newsdesk/archive_rundowns`, { params })
  }
}
